import React, {useEffect,useRef,useState,ReactNode,isValidElement,cloneElement,ReactElement,} from 'react';

interface ErrorBlockProps {
    children: ReactNode;
    duration?: number;
    highlightClass?: string;
    customClass?: string;
}

const ErrorBlock: React.FC<ErrorBlockProps> = ({
    children,
    duration = 2000,
    highlightClass = 'fade-bg',
    customClass = '',
}) => {
    const [highlight, setHighlight] = useState(false);
    const timers = useRef<NodeJS.Timeout[]>([]);

    useEffect(() => {
        setHighlight(false);
        const timer = setTimeout(() => setHighlight(true), duration);
        timers.current.push(timer);

        return () => {
            timers.current.forEach(clearTimeout);
        };
    }, [children]);

//Making this as generic function to apply Highliht to any html block of codde with their specific classes and id's
    return (
        <>
            {React.Children.map(children, (child) => {
                if (isValidElement(child) && typeof child.type === 'string') {
                    const child = children as ReactElement<any>;
                    const existingClassName = child.props.className || '';
                    return cloneElement(child, {
                        className: `${highlight ? highlightClass : ''} ${customClass} ${existingClassName}`.trim()
                    });
                }
                return child;
            })}
        </>
    );
};

export default ErrorBlock
